import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
    selector: 'app-image-gallery',
    templateUrl: './image-gallery.component.html',
    styleUrl: './image-gallery.component.scss',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ImageGalleryComponent {
  readonly images = input<any>();
  readonly displayImageDialog = input(false);
  readonly visibleChangeUpdate = output<void>();
  responsiveOptions: any[] = [
    { breakpoint: '1024px', numVisible: 5 }, { breakpoint: '768px', numVisible: 3 }, { breakpoint: '560px', numVisible: 1 }
  ];

  /**
   * 
   * @param $event 
   */
  visibleChange($event:boolean) {
    this.visibleChangeUpdate.emit();
  }
}